import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleDownFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.5395 9.97873C16.5356 9.98464 16.5316 9.99056 16.5277 9.9965L13.0568 15.2066C12.9564 15.3574 12.8633 15.4972 12.7768 15.6045C12.6865 15.7166 12.5613 15.8486 12.3781 15.9246C12.136 16.0251 11.864 16.0251 11.6219 15.9246C11.4387 15.8486 11.3135 15.7166 11.2232 15.6045C11.1367 15.4972 11.0436 15.3574 10.9432 15.2067L7.46051 9.97875C7.33774 9.79448 7.22734 9.62878 7.1512 9.48818C7.075 9.34748 6.98794 9.15436 7.00138 8.92895C7.01859 8.64063 7.16103 8.37428 7.3912 8.20003C7.57116 8.06379 7.78002 8.02916 7.93927 8.01456C8.0984 7.99997 8.2974 7.99999 8.5187 8L15.46 8C15.4671 8 15.4742 8 15.4813 8C15.7026 7.99999 15.9016 7.99997 16.0607 8.01456C16.22 8.02917 16.4288 8.06379 16.6088 8.20003C16.839 8.37428 16.9814 8.64063 16.9986 8.92895C17.0121 9.15436 16.925 9.34748 16.8488 9.48818C16.7727 9.62878 16.6623 9.79447 16.5395 9.97873Z",
		fill: "currentColor"
	})
});
export default SvgTriangleDownFilled;
